// Mobilny overlay z zakładkami: Kategorie, Filtry, Sortowanie
// @ts-nocheck

import React, { FC, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { X } from 'react-bootstrap-icons';

import {
  IPaginationResponse,
  IProductsFilter,
  IProductsRequest,
  IProductsSortMethod
} from 'api/types';
import { Categories } from 'pages/Products/components';
import FiltersSidebar from 'pages/Products/components/FiltersSidebar/FiltersSidebar';

import styles from 'theme/pages/Products/components/MobileFiltersOverlay/MobileFiltersOverlay.module.scss';

interface IFilter {
  filter_id: string;
  filter_value: string;
}

type ISortResponse = IPaginationResponse<IProductsSortMethod>;

interface IProps {
  categoryId?: number;
  queryFilters: IFilter[];
  filtersData?: IProductsFilter[];
  productsSortingMethodsData?: ISortResponse;
  onChange: (filters: IFilter[]) => void;
  close: () => void;
  setSort: (id: string) => void;
  productsQuery: IProductsRequest;
  searchKeyword?: string;
  productsCount?: number;
  initialTab?: TabType; // Początkowa zakładka
}

type TabType = 'categories' | 'filters' | 'sorting';

const MobileFiltersOverlay: FC<IProps> = ({
  onChange,
  filtersData,
  productsQuery,
  setSort,
  productsSortingMethodsData,
  close,
  categoryId,
  queryFilters,
  searchKeyword,
  productsCount,
  initialTab = 'categories'
}) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<TabType>(initialTab);
  const [currentFilters, setCurrentFilters] = useState<IFilter[]>(queryFilters);

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Pages-Products-components-MobileFiltersOverlay'
      )}>
      {/* Biały panel z zawartością */}
      <div className={styles.panel}>
        {/* Header z nazwą zakładki */}
        <div className={styles.header}>
          <h2 className={styles.title}>
            {t(activeTab === 'categories' ? 'Kategorie' : activeTab === 'filters' ? 'Filtry' : 'Sortowanie')}
          </h2>
          <button className={styles.closeButton} onClick={close}>
            <X />
          </button>
        </div>

      {/* Zawartość zakładki */}
      <div className={styles.content}>
        {activeTab === 'categories' && (
          <Categories
            searchKeyword={searchKeyword}
            chosenCategoryId={categoryId}
            productsQueryParams={productsQuery}
          />
        )}

        {activeTab === 'filters' && (
          <div className={styles.filtersWrapper}>
            <FiltersSidebar
              categoryId={categoryId}
              onChange={onChange}
              queryFilters={queryFilters}
              filtersData={filtersData}
              productsCount={productsCount}
              onFiltersChange={setCurrentFilters}
              hideActions={true}
            />
          </div>
        )}

        {activeTab === 'sorting' && (
          <div className={styles.sortingContent}>
            {productsSortingMethodsData?.items.map((item) => {
              const isSelected = productsQuery?.sort_method === item.id;
              return (
                <button
                  key={item.id}
                  className={classnames(styles.sortOption, {
                    [styles.selected]: isSelected
                  })}
                  onClick={() => {
                    setSort(item.id);
                    // Zamknij po wyborze sortowania
                    setTimeout(() => close(), 300);
                  }}>
                  {isSelected && (
                    <svg
                      className={styles.checkIcon}
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M16.6667 5L7.50004 14.1667L3.33337 10"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                  <span className={styles.sortLabel}>{item.name}</span>
                </button>
              );
            })}
          </div>
        )}
      </div>

      {/* Przyciski akcji na dole - dla wszystkich zakładek */}
      <div className={styles.footer}>
        <button
          onClick={() => {
            if (activeTab === 'filters') {
              // Zastosuj filtry i zamknij
              onChange(currentFilters);
              close();
            } else if (activeTab === 'sorting') {
              // Dla sortowania - zamknij (sortowanie jest już zastosowane przy kliknięciu)
              close();
            } else {
              // Dla kategorii - zamknij
              close();
            }
          }}
          className={styles.filterButton}>
          <Trans>Filtruj</Trans>
          {activeTab === 'filters' && productsCount !== undefined && ` (${productsCount})`}
        </button>
        <button
          onClick={() => {
            if (activeTab === 'filters') {
              setCurrentFilters([]);
              onChange([]);
            } else if (activeTab === 'sorting') {
              // Dla sortowania - reset do domyślnego
              setSort('');
            }
          }}
          className={styles.clearButton}>
          <Trans>Wyczyść</Trans>
        </button>
      </div>
      </div>
    </div>
  );
};

export default MobileFiltersOverlay;

